import { type ReactNode, type ButtonHTMLAttributes, forwardRef } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'success'
  size?: 'sm' | 'md' | 'lg'
  icon?: ReactNode
  iconOnly?: boolean
  loading?: boolean
  children?: ReactNode
}

const Spinner = ({ size = 14 }: { size?: number }) => (
  <svg
    width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
    style={{ animation: 'spin 1s linear infinite' }}
  >
    <path d="M21,12a9,9,0,1,1-6.219-8.56" />
  </svg>
)

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  variant = 'primary',
  size = 'md',
  icon,
  iconOnly = false,
  loading = false,
  disabled = false,
  children,
  className,
  ...props
}, ref) => {
  const sizeClass = size === 'sm' ? 'v3-btn-sm' : size === 'lg' ? 'v3-btn-lg' : ''
  const variantClass = `v3-btn-${variant}`
  const iconOnlyClass = iconOnly ? 'v3-btn-icon' : ''

  return (
    <button
      ref={ref}
      className={`v3-btn ${variantClass} ${sizeClass} ${iconOnlyClass} ${className || ''}`.trim()}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? <Spinner size={size === 'sm' ? 13 : size === 'lg' ? 15 : 14} /> : icon}
      {!iconOnly && children}
    </button>
  )
})

Button.displayName = 'Button'
